import Axios from 'axios'
import { IShoppingCartParams } from 'models/ShoppingCart'

export const getConfigShoppingCartApi = async (params: IShoppingCartParams) => {
	const response = await Axios.get(`CarroConfig`, { params })
	return response.data
}
